package io.horion.cv.components.auth

import androidx.compose.runtime.*
import io.horion.cv.api.utils.TokenRepository
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

private sealed class AuthState {
    data object Checking : AuthState()
    data object Authenticated : AuthState()
    data object Denied : AuthState()
}

@Composable
fun RequireAuth(content: @Composable () -> Unit) {
    var authState by remember { mutableStateOf<AuthState>(AuthState.Checking) }

    LaunchedEffect(Unit) {
        val authenticated = runCatching { TokenRepository.checkAuthentication() }.getOrDefault(false)
        if (authenticated) {
            authState = AuthState.Authenticated
        } else {
            authState = AuthState.Denied
            TokenRepository.redirectToAuth()
        }
    }

    when (authState) {
        is AuthState.Checking -> AuthPlaceholder("Vérification de votre session...")
        is AuthState.Denied -> AuthPlaceholder("Redirection vers la page de connexion...")
        is AuthState.Authenticated -> content()
    }
    content()
}

@Composable
private fun AuthPlaceholder(message: String) {
    Div(attrs = {
        style {
            property("display", "flex")
            property("align-items", "center")
            property("justify-content", "center")
            property("min-height", "100vh")
            property("width", "100%")
            property("font-family", "Inter, sans-serif")
            property("font-size", "14px")
        }
    }) {
        Text(message)
    }
}
